import MenuReservationItem from "@/model/dailymenu/MenuReservationItem";

export default class MenuReservation {
  private constructor (
    readonly reservationList: MenuReservationItem[],

  ) {}

  static createEmpty (): MenuReservation {
    return new MenuReservation([])
  }

  static createFromResponse (responseData: any): MenuReservation {

    return new MenuReservation(
        responseData.map( (item:any):MenuReservationItem => MenuReservationItem.createFromResponse(item))
    )

  }
}
